// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__oUjuP","footer":"ModalFilter_footer__2fXMQ"};